import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate';
import Buefy from 'buefy'
import wysiwyg from "vue-wysiwyg";
import axios from "axios"

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // console.log(response);
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  if(error.response.status == 401){
    console.log("Session has expired")
    store.dispatch('logout');
    router.go(0);
  }
  return Promise.reject(error);
});

Vue.use(wysiwyg, {
  // { [module]: boolean (set true to hide) }
  hideModules: { "link": true, "code" : true }
}); // config is optional. more below

Vue.use(Buefy, {
  defaultIconPack: 'fas'
});
Vue.use(VeeValidate);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
